import React from 'react'
import { Tooltip } from '@mui/material'
import { useTheme } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { MenuItem as MenuItemType } from '../../../types/menuItem.types'

interface MenuItemProps {
  item: MenuItemType
  className?: string
}
/**
 * in order sto style directly this component we need to use forwardRef, and pass the className to the Link component
 */
const IconMenuItem = React.forwardRef<HTMLAnchorElement, MenuItemProps>(({ item, className }, ref) => {
  const theme = useTheme()
  const location = useLocation()

  const getIconColor = (itemUrl: string) => {
    const isActive = location.pathname === itemUrl || location.pathname.startsWith(itemUrl + '/')
    return isActive ? theme.palette.secondary.main : theme.palette.secondary.contrastText
  }

  return (
    <Link
      ref={ref}
      key={item.url}
      to={item.url}
      aria-label={item.label}
      aria-current={location.pathname === item.url || location.pathname.startsWith(item.url + '/') ? 'page' : undefined}
      className={className}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Tooltip title={item.label}>
        {React.cloneElement(item.icon, {
          customColor: getIconColor(item.url),
          className: 'navigation-icon',
        })}
      </Tooltip>
    </Link>
  )
})

IconMenuItem.displayName = 'IconMenuItem'

export default IconMenuItem
